import {signInCreateNewAccountStyles} from "@insite/content-library/Widgets/SignIn/SignInCreateNewAccount";
import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

signInCreateNewAccountStyles.signInCreateNewAccountTitle = {
    variant: "h3",
    css: css`
    color: ${getColor("secondary")};
    margin-bottom: 0px;
    `
}

signInCreateNewAccountStyles.signInCreateNewAccountGridContainer = {
    css: css`
    background: ${getColor("info.contrast")};
    padding: 30px;
    margin: 0;
    min-height: 345px;
    `
}

signInCreateNewAccountStyles.signInCreateNewAccountTextGridItem = {
    width: 12,
    css: css`
    padding-top: 0px;
    padding-bottom: 0px;
    `
}

signInCreateNewAccountStyles.createNewAccountButton = {
    variant: "primary",
}